import script from "./TableList.vue?vue&type=script&setup=true&lang=js"
export * from "./TableList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__